import React from "react";
import FullImage from "../Modal/FullImage";

function ImageMessage({ src, alt, deletedCaption }) {
  const [view, setView] = React.useState(false);
  const showDeleted = Boolean(deletedCaption);
  const srcUrl = "" + src;

  return (
    <>
      <div
        className={`image-message-wrap ${showDeleted ? "image-message-wrap--deleted" : ""}`}
      >
        <img
          src={srcUrl}
          alt={alt}
          className="img-fluid image-message-wrap__img"
          style={{ maxWidth: "300px", maxHeight: "300px" }}
          onClick={() => setView(true)}
        />
        {showDeleted && (
          <span className="image-message-deleted-label" title={deletedCaption}>
            {deletedCaption}
          </span>
        )}
      </div>
      {view && (
        <FullImage
          show={view}
          image={srcUrl}
          onHide={() => setView(false)}
          imageType={"image"}
        />
      )}
    </>
  );
}

export default ImageMessage;
